import React from 'react';

const ConfigureCareerPageLogo = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="4" fill="white" />
    <rect x="3.16669" y="3.16669" width="25.6667" height="25.6667" rx="4" fill="#48CAE4" />
    <path
      d="M3.16669 7.16669C3.16669 4.95755 4.95755 3.16669 7.16669 3.16669H24.8334C27.0425 3.16669 28.8334 4.95755 28.8334 7.16669V10.1667H3.16669V7.16669Z"
      fill="#00B4D8"
    />
    <path
      d="M5.5 6.66667C5.5 6.02233 6.02233 5.5 6.66667 5.5C7.311 5.5 7.83333 6.02233 7.83333 6.66667C7.83333 7.311 7.311 7.83333 6.66667 7.83333C6.02233 7.83333 5.5 7.311 5.5 6.66667Z"
      fill="#ADE8F4"
    />
    <rect x="9" y="5.5" width="2.33333" height="2.33333" rx="1.16667" fill="#ADE8F4" />
    <rect x="12.5" y="5.5" width="2.33333" height="2.33333" rx="1.16667" fill="#ADE8F4" />
  </svg>
);

export default ConfigureCareerPageLogo;
